<div class="notfound-record-text" [style.paddingTop.px]="top">
  <p>{{ message }}</p>
</div>
